import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_PRODUCT:
    case actions.CREATE_PRODUCT_CATEGORY: {
      return {
        ...state,
        isCreating: true,
      };
    }
    case actions.CREATE_PRODUCT_ENDED:
    case actions.CREATE_PRODUCT_CATEGORY_ENDED: {
      return {
        ...state,
        isCreating: false,
      };
    }
    case actions.SEARCH_PRODUCTS:
    case actions.SEARCH_PRODUCT_CATEGORIES:
    case actions.FIND_PRODUCT_CATEGORY: {
      return {
        ...state,
        isSearching: true,
      };
    }
    case actions.SEARCH_PRODUCTS_ENDED:
    case actions.SEARCH_PRODUCT_CATEGORIES_ENDED:
    case actions.FIND_PRODUCT_CATEGORY_ENDED: {
      return {
        ...state,
        isSearching: false,
      };
    }
    case actions.UPDATE_PRODUCT:
    case actions.UPDATE_PRODUCT_CATEGORY: {
      return {
        ...state,
        isUpdating: true,
      };
    }
    case actions.UPDATE_PRODUCT_ENDED:
    case actions.UPDATE_PRODUCT_CATEGORY_ENDED: {
      return {
        ...state,
        isUpdating: false,
      };
    }
    case actions.DELETE_PRODUCTS:
    case actions.DELETE_PRODUCT_CATEGORIES: {
      return {
        ...state,
        isDeleting: true,
      };
    }
    case actions.DELETE_PRODUCTS_ENDED:
    case actions.DELETE_PRODUCT_CATEGORIES_ENDED: {
      return {
        ...state,
        isDeleting: false,
      };
    }
    default:
      return state;
  }
}
